class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    
    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }
    
    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management || variantInventoryObject.policy === 'continue') {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.policy === 'continue') {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);
        
        return;
      }

      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--low');
      this.productInventoryNode.classList.remove('inventory-status--sold-out');

      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
        
      this.productInventoryNode.classList.remove('hide');
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.remove('inventory-status--low', 'inventory-status--sold-out');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
      this.productInventoryNode.classList.remove('hide');
    } else {
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.classList.remove('hide');
    }
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    
    const personalizeBtn = productForm.querySelector('.product-form__personalize');
    if (personalizeBtn) {
      const personalizePrice = parseFloat(personalizeBtn.dataset.price);
      const variantPrice = parseFloat(this.currentVariant.price);
      const priceDiff = personalizePrice - variantPrice;
      const priceDiffMoney = Woolman.Utils.formatMoney(priceDiff);

      if (priceDiff > 0) {
        personalizeBtn.textContent = window.variantStrings.personalize_for_price.replace('{{ money }}', priceDiffMoney);
      } else {
        personalizeBtn.textContent = window.variantStrings.personalize;
      }
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Store product handles to history for "recently-viewed" section.
(function() {
  const history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
  const productHandle = window.location.pathname.split('/').pop();
  if (!productHandle) return;
  if (!history.includes(productHandle)) {

    if (history.length >= 10) { // only store up to 10 recently viewed products
      history.shift();
    }
    
    history.push(productHandle);
    sessionStorage.setItem('Woolman_Product_History', history.join(','));
  }
})();

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);

          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });

        // Accessibility: Scroll to buy bar when focused via keyboard
    this.addEventListener('focusin', (e) => {
  
        //this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.scrollTo({ top: 1100, behavior: 'smooth' });
    });

    // Track last interaction type
    /*window.addEventListener('keydown', () => { ProductBuyBar.lastInteraction = 'keyboard'; });
    window.addEventListener('mousedown', () => { ProductBuyBar.lastInteraction = 'mouse'; });
    window.addEventListener('touchstart', () => { ProductBuyBar.lastInteraction = 'touch'; });*/
  
  }
}

customElements.define("product-buy-bar", ProductBuyBar);

class UpsellProductRecommendations extends HTMLElement {
  constructor() {
    super();
    
    // Accessibility properties
    this.currentPosition = 0;
    this.itemsPerView = 1;
    this.isAnimating = false;

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('upsell-product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            
            // Initialize accessibility features after content loads
            this.initAccessibility();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    
    // Initialize accessibility if content already exists
    setTimeout(() => {
      if (this.querySelector('.upsell-carousel-accessible')) {
        this.initAccessibility();
      }
    }, 100);
  }

  initAccessibility() {
    if (!this.classList.contains('upsell-carousel-accessible')) return;
    
    this.setupElements();
    this.calculateItemsPerView();
    this.bindEvents();
    this.updateButtonStates();
    this.setupKeyboardNavigation();
    this.updateItemAccessibility();
  }

  setupElements() {
    this.track = this.querySelector('.upsell-products-list');
    this.trackContainer = this.querySelector('.upsell-products-track');
    this.items = this.querySelectorAll('.upsell-product-item');
    this.prevBtn = this.querySelector('[data-carousel-btn="prev"]');
    this.nextBtn = this.querySelector('[data-carousel-btn="next"]');
    this.statusRegion = this.querySelector('[role="status"]');
  }

  calculateItemsPerView() {
    if (!this.trackContainer) return;
    
    const containerWidth = this.trackContainer.offsetWidth;
    const itemWidth = this.items[0]?.offsetWidth || 280;
    const gap = 16;
    
    this.itemsPerView = Math.max(1, Math.floor((containerWidth + gap) / (itemWidth + gap)));
    this.itemsPerView = Math.min(this.itemsPerView, this.items.length);
  }

  bindEvents() {
    this.prevBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.navigate('prev', true);
    });

    this.nextBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.navigate('next', true);
    });
  }

  setupKeyboardNavigation() {
    this.addEventListener('keydown', (e) => {
      if (e.target.closest('[data-carousel-btn]')) {
        this.handleButtonKeydown(e);
      }
    });
  }

  handleButtonKeydown(e) {
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        this.navigate('prev', true);
        break;
      case 'ArrowRight':
        e.preventDefault();
        this.navigate('next', true);
        break;
      case 'Home':
        e.preventDefault();
        this.goToSlide(0, true);
        break;
      case 'End':
        e.preventDefault();
        this.goToSlide(this.getMaxPosition(), true);
        break;
    }
  }

  navigate(direction, shouldAnnounce = false) {
    if (this.isAnimating || !this.items.length) return;

    const maxPosition = this.getMaxPosition();
    let newPosition = this.currentPosition;

    if (direction === 'prev') {
      newPosition = Math.max(0, this.currentPosition - 1);
    } else if (direction === 'next') {
      newPosition = Math.min(maxPosition, this.currentPosition + 1);
    }

    if (newPosition !== this.currentPosition) {
      this.goToSlide(newPosition, shouldAnnounce);
    }
  }

  goToSlide(position, shouldAnnounce = false) {
    if (this.isAnimating || position === this.currentPosition) return;

    this.isAnimating = true;
    this.currentPosition = Math.max(0, Math.min(this.getMaxPosition(), position));

    this.updateTrackPosition();
    this.updateButtonStates();
    this.updateItemAccessibility();

    if (shouldAnnounce) {
      this.announceChange();
    }

    setTimeout(() => {
      this.isAnimating = false;
    }, 300);
  }

  updateTrackPosition() {
    if (!this.track || !this.items.length) return;

    const itemWidth = this.items[0].offsetWidth;
    const gap = 16;
    const translateX = -(this.currentPosition * (itemWidth + gap));

    this.track.style.transform = `translateX(${translateX}px)`;
  }

  updateButtonStates() {
    const maxPosition = this.getMaxPosition();

    if (this.prevBtn) {
      const isDisabled = this.currentPosition === 0;
      this.prevBtn.setAttribute('aria-disabled', isDisabled.toString());
      this.prevBtn.disabled = isDisabled;
    }

    if (this.nextBtn) {
      const isDisabled = this.currentPosition >= maxPosition;
      this.nextBtn.setAttribute('aria-disabled', isDisabled.toString());
      this.nextBtn.disabled = isDisabled;
    }
  }

  updateItemAccessibility() {
    this.items.forEach((item, index) => {
      const isVisible = this.isItemVisible(index);
      this.setItemAccessibility(item, isVisible);
    });
  }

  setItemAccessibility(item, isVisible) {
    const focusableInItem = item.querySelectorAll('a, button, input, select, textarea');
    
    focusableInItem.forEach(element => {
      if (isVisible) {
        element.removeAttribute('tabindex');
      } else {
        //element.setAttribute('tabindex', '-1');
      }
    });

    //item.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  }

  isItemVisible(index) {
    return index >= this.currentPosition && index < this.currentPosition + this.itemsPerView;
  }

  getMaxPosition() {
    return Math.max(0, this.items.length - this.itemsPerView);
  }

  announceChange() {
    if (!this.statusRegion) return;

    const startItem = this.currentPosition + 1;
    const endItem = Math.min(this.currentPosition + this.itemsPerView, this.items.length);
    const totalItems = this.items.length;

    let message;
    if (this.itemsPerView === 1) {
      message = `Showing item ${startItem} of ${totalItems}`;
    } else {
      message = `Showing items ${startItem} to ${endItem} of ${totalItems}`;
    }

    this.statusRegion.textContent = message;
  }
}

customElements.define('upsell-product-recommendations', UpsellProductRecommendations);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);